import React from 'react';

const AboutUsSection = () => {
  return (
    <div className="container my-5" id="aboutus">
      <section className="text-center" id="opinion">
        <h2>About Us</h2>
        <div className="row mt-4">
          <div className="col-md-1 mb-md-0 mb-4"></div>
          <div className="col-md-10 mb-md-0 mb-4">
            <img
              src="/images/Bitejoy/1767899401204.jpg"
              alt="avatar"
              className="mb-4 about-banner-image"
            />
            <h2 className="mb-3" style={{ marginTop: '30px' }}>
              Our Promise
            </h2>
            <p>
              <br />
            </p>
            Honest ingredients, hygienic manufacturing, and consistent quality.
            We're not just selling chocolates - we're building trust, one bite at
            a time.
            <p>
              <br />
            </p>
            <h5>Order With Us</h5>
            <h6>Available online and offline</h6>
            <h6>Retail & bulk orders accepted</h6>
            <h6>Pan-India delivery available</h6>
          </div>
          <div className="col-md-1 mb-0"></div>
        </div>
      </section>
    </div>
  );
};

export default AboutUsSection;
